import { ChangeDetectionStrategy, Component, OnInit, TransferState, Type, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { DISPLAY_VERSION } from 'ish-core/configurations/state-keys';
import { AppFacade } from 'ish-core/facades/app.facade';

/**
 * Footer Component
 */
@Component({
  selector: 'ish-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterComponent implements OnInit {
  appVersion: string;
  private transferState = inject(TransferState);
  private appFacade = inject(AppFacade);
  lazyFooterComponent$: Observable<Type<unknown>> = this.appFacade.loadLazyComponent('footer');

  ngOnInit() {
    if (!SSR) {
      this.appVersion = this.transferState.get(DISPLAY_VERSION, '');
    }
  }
}
